import { deepStringReplace } from "#common";
import {
  REGEX_CONTAINS_EMAIL,
  REGEX_CONTAINS_FINNISH_MOBILE_PHONE,
  REGEX_CONTAINS_FINNISH_SSN,
  REGEX_CONTAINS_SWEDISH_MOBILE_PHONE,
  REGEX_CONTAINS_SWEDISH_SSN,
} from "./regex";

const scrubbers = [
  {
    searchValue: REGEX_CONTAINS_EMAIL,
    replaceValue: "[Client Filtered Email]",
  },
  {
    searchValue: REGEX_CONTAINS_SWEDISH_MOBILE_PHONE,
    replaceValue: "[Client Filtered Phone]",
  },
  {
    searchValue: REGEX_CONTAINS_FINNISH_MOBILE_PHONE,
    replaceValue: "[Client Filtered Phone]",
  },
  {
    searchValue: REGEX_CONTAINS_SWEDISH_SSN,
    replaceValue: "[Client Filtered SSN]",
  },
  {
    searchValue: REGEX_CONTAINS_FINNISH_SSN,
    replaceValue: "[Client Filtered SSN]",
  },
];

/**
 * Scrubs sensitive information from an object or string.
 * @param obj The object or string to scrub.
 * @returns The scrubbed object or string.
 */
export function deepScrub<T>(obj: T): T {
  return deepStringReplace(obj, scrubbers);
}
